import React, { useContext } from 'react';
import { Nav } from 'react-bootstrap';
import { Outlet, NavLink } from 'react-router-dom';
import { TableContext } from '../../contexts/tableContext';
import styles from './settings.module.scss';

const tabClass = ({ isActive }) =>
  isActive ? styles.settingsgeneral : styles.settingslinks;

function SettingsLayout() {
  const { dashboardStyle, formthemeStyle } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);

  return (
    <div className={styles[bodyStyle]}>
      <div
        className={styles[dashboardStyle]}
        style={{ height: '100vh' }}
        id={styles.dashboardcont2}
      >
        <div className={styles.settingsection}>
          <div>
            <Nav as="ul" className={styles[formthemeStyle]} id={styles.layoutnav}>
              <Nav.Item as="li" className={styles.navitemli}>
                <NavLink to="/settings" end className={tabClass}>
                  General
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li" className={styles.navitemli}>
                <NavLink to="/settings/profile" className={tabClass}>
                  Profile
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li" className={styles.navitemli}>
                <NavLink to="/settings/change-password" className={tabClass}>
                  Change Password
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li" className={styles.navitemli}>
                <NavLink to="/settings/create-route" className={tabClass}>
                  Create Route
                </NavLink>
              </Nav.Item>
              {/* <Nav.Item as="li" className={styles.navitemli}>
                <Link to="/api" className={styles[settingsapiStyle]}>
                  API
                </Link>
              </Nav.Item>
              <Nav.Item as="li" className={styles.navitemli}>
                <Link to="/preferences" className={styles[settingsprefStyle]}>
                  Preferences
                </Link>
              </Nav.Item> */}
            </Nav>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default SettingsLayout;
